import React from "react";
import { useModal } from "@Contexts/ModalContext";
import ChoosePayment from "@Modals/payment/ChoosePayment";
import EntryBasedPass from "@Modals/payment/EntryBasedPass";
import PhoneVerification from "@Modals/payment/PhoneVerification";
import PaymentPendingModal from "@Modals/payment/PaymentPendingModal";

const Modal = () => {
  const { isOpen, closeModal, type } = useModal();

  if (!isOpen) return null;

  // PaymentPendingModal has its own complete modal structure
  if (type === "paymentPending") {
    return <PaymentPendingModal />;
  }

  return (
    <div className="fixed inset-0 z-20 flex items-center justify-center bg-modal" onClick={closeModal}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative h-full w-full max-w-[640px] rounded-none bg-white p-4 shadow-modal xs:h-auto xs:w-[85%] xs:rounded-xl lg:p-8"
      >
        {type === "choosePayment" && <ChoosePayment />}
        {type === "entryBasedPass" && <EntryBasedPass />}
        {type === "phoneVerification" && <PhoneVerification />}
      </div>
    </div>
  );
};

export default Modal;
